export interface ICognitoSettings {
    ClientId: string;
    UserPoolId: string;
    Domain: string;
}

export interface IDataAnalyticsSettings {
    apiUrl: string;
}

export interface IPendoSettings {
    EnvironmentName: string;
}

export interface IEnvironment {
    /**
     * The environment of the backend services sdweb is running against
     * @example stage01, stage02, prod
     */
    kcfEnv: string;
    apiBaseUrl: string;
    cognito: ICognitoSettings;
    pendo?: IPendoSettings;
    gatewayApiBaseUrl?: string;
    configCatApi: string;
    isLocalDevelopment: boolean;
    isSentryEnabled: boolean;
    sentryUrl: string;
}

export const Environment: IEnvironment = {
    kcfEnv: process.env.KCF_ENV,
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    cognito: {
        ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
        UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        Domain: process.env.REACT_APP_COGNITO_DOMAIN,
    },
    pendo: process.env.REACT_APP_PENDO_ENV
        ? {
              EnvironmentName: process.env.REACT_APP_PENDO_ENV,
          }
        : undefined,
    gatewayApiBaseUrl: process.env.REACT_APP_GATEWAY_API_BASE_URL,
    configCatApi: process.env.REACT_APP_CONFIG_CAT_API,
    isLocalDevelopment: process.env.NODE_ENV === 'development',
    isSentryEnabled: process.env.SENTRYIO_ENABLED === 'true',
    sentryUrl: process.env.SENTRYIO_INGEST_URL,
};
